// Planner — blueprint-styled full planner at /:lang/planner.
// Reuses the complete planner engine and wraps it in the CAD-aesthetic
// chrome defined in planner-bp.css + planner-bp/chrome.ts.
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()

import '../css/style.css'
import '../css/three-view.css'
import '../css/ai-features.css'
import '../css/planner-bp.css'
import '../js/components'

// Engine bootstrap — identical to `application` entrypoint so the
// planner, catalog loader, autosave, and feature flags behave the same.
import '../js/planner/app.ts'

import { loadFeatureFlags, featureEnabled } from '../js/shared/features.ts'
import { initAiFeatures } from '../js/ai/ai-features.ts'
import { initShortcutHelp } from '../js/planner/shortcut-help.ts'
import { initPlannerBpChrome } from '../js/planner-bp/chrome.ts'
import { initFeedback } from '../js/pages/feedback.ts'
import { initSearch } from '../js/shared/search.ts'
import { initDxfImport } from '../js/planner/dxf-import.ts'
import { initPlotTemplates } from '../js/planner/templates.ts'

document.addEventListener('DOMContentLoaded', () => {
  initSearch()
  initFeedback()

  loadFeatureFlags().then(() => {
    // Planner shell must wait for flags so gated panels hide before
    // the first paint settles.
    initPlannerBpChrome()

    if (featureEnabled('ai_assistant')) {
      initAiFeatures()
    }
    initShortcutHelp()
    initDxfImport()
    initPlotTemplates()
  })
})
